import {
    BufferAttribute,
    Mesh,
    MeshBasicMaterial,
    Scene,
    ShaderMaterial,
    SphereGeometry,
    Vector3,
    WebGLRenderer
} from "three";
import {PanoramaModel} from "features/apartmentViewer/ApartmentViewer/models/PanoramaModel";
import {Layer} from "features/apartmentViewer/ApartmentViewer/layers/Layer";
import {CameraHandler} from "features/apartmentViewer/ApartmentViewer/services/CameraHandler";
import {CanvasService} from "features/apartmentViewer/ApartmentViewer/services/CanvasService";
import {
    PanoramaMaterialFactory
} from "features/apartmentViewer/ApartmentViewer/shaders/panoramaMaterial/PanoramaMaterialFactory";

export class PanoramaLayer extends Layer {

    public sphere: Mesh;
    public scene: Scene;

    public static LatPoints = 400;
    public static LonPoints = 400;
    private depthMaterial: ShaderMaterial;

    constructor(
        canvasService: CanvasService,
        private renderer: WebGLRenderer,
        private cameraHandler: CameraHandler,
    ) {
        super(canvasService);

        this.scene = new Scene();
        this.isActive = false;
    }

    setPanoramaData(panoramaData: PanoramaModel) {
        const sphereGeometry = new SphereGeometry(1, PanoramaLayer.LatPoints, PanoramaLayer.LonPoints);

        sphereGeometry.scale(-1, 1, 1);
        sphereGeometry.rotateY(-Math.PI /2);


        const positions = sphereGeometry.attributes.position;
        const updatedPositions = new Float32Array(3 * positions.count);

        // Loop through the sphere vertices and adjust their position based on depth data
        for (let i = 0; i < positions.count; i++) {
            const vertex = new Vector3(
                positions.array[3 * i],
                positions.array[3 * i + 1],
                positions.array[3 * i + 2]
            );
            let depth = panoramaData.depthManager.getDepth(vertex);
            if (depth > 100) depth = 100;

            updatedPositions[3 * i] = vertex.x * depth;
            updatedPositions[3 * i + 1] = vertex.y * depth;
            updatedPositions[3 * i + 2] = vertex.z * depth;
        }

        // Update the geometry with new positions
        sphereGeometry.setAttribute('position', new BufferAttribute(updatedPositions, 3));


        if(this.depthMaterial) this.depthMaterial.dispose();

        if(this.sphere) {
            this.scene.remove(this.sphere);
            this.sphere.material = new MeshBasicMaterial();
            this.sphere.geometry.dispose();
        }


        this.depthMaterial = PanoramaMaterialFactory.createMaterial(panoramaData.texture);

        this.sphere = new Mesh(sphereGeometry, new MeshBasicMaterial({ map: panoramaData.texture }));
        this.sphere.position.copy(panoramaData.marker?.position);
        this.scene.add(this.sphere);

        this.isActive = true;

    }

    update() {
        // Update the panorama sphere
        this.renderer.setClearColor(0,0);
        this.renderer.setRenderTarget(this.renderTexture);
        this.renderer.render(this.scene, this.cameraHandler.camera);
        this.renderer.setRenderTarget(null);
    }

    dispose() {
        this.depthMaterial.dispose();
        this.sphere.geometry.dispose();
    }
}


